import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import api, { formatApiError } from '../api';
import { useNoIndex } from '../ProtectedRoute';

const ForgotPasswordPage = () => {
  useNoIndex();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950 px-4" data-testid="forgot-page">
      <div className="relative w-full max-w-md">
        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8 shadow-2xl">
          <h1 className="text-xl font-bold text-white mb-2">Mot de passe oublié</h1>
          {sent ? (
            <div className="text-center py-6" data-testid="forgot-success">
              <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto mb-3" />
              <p className="text-neutral-300">Si un compte existe pour cette adresse, un email de réinitialisation vient d'être envoyé.</p>
              <Link to="/connexion" className="inline-block mt-5 text-red-500 hover:text-red-400 text-sm">Retour à la connexion</Link>
            </div>
          ) : (
            <>
              <p className="text-neutral-400 text-sm mb-5">Saisissez votre email, nous vous enverrons un lien pour réinitialiser votre mot de passe.</p>
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <Label htmlFor="email" className="text-neutral-300">Email</Label>
                  <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="vous@exemple.fr" required data-testid="forgot-email-input"
                    className="mt-1.5 bg-neutral-800 border-neutral-700 text-white placeholder:text-neutral-500" />
                </div>
                {error && <p className="text-sm text-red-400" data-testid="forgot-error">{error}</p>}
                <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
                  className="w-full bg-red-700 hover:bg-red-600 text-white h-11">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Mail className="w-4 h-4 mr-2" />}
                  Envoyer le lien
                </Button>
              </form>
              <Link to="/connexion" className="flex items-center gap-1 mt-5 text-sm text-neutral-400 hover:text-red-500">
                <ArrowLeft className="w-4 h-4" /> Retour à la connexion
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
